import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { SystemSettingsService } from "../../services/system-settings.service";
import {PriceListService} from "../../../product/services/price-list.service";

@Component({
  selector: 'app-system-settings',
  templateUrl: './system-settings.component.html',
  styleUrls: ['./system-settings.component.scss']
})
export class SystemSettingsComponent implements OnInit {
  systemSettingsForm: FormGroup;
  saving = false;
  data: any;
  isLoading = true;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  defaultPriceLists: any[] = [];
  defaultPriceListSelected: number | undefined;

  constructor(
      private fb: FormBuilder,
      private systemSettingsService: SystemSettingsService,
      private translate: TranslateService,
      private priceListService: PriceListService,
      private toastr: ToastrService,
      private router: Router
  ) {
    this.systemSettingsForm = this.fb.group({
      isSingleCompany: [false],
      isBranches: [false],
      isBudgetAutomatic: [false],
      isCumulatedZoneQuantity: [false],
      isInventoryZeroing: [false],
      isScaleRange2021: [false],
      isUpdatingInventoryQuantities: [false],
      isPitGrossSalaryPercentage: [false],
      pitGrossSalaryPercentage: [{value: 0, disabled: true},
        [Validators.required, Validators.min(0), Validators.max(100)]],
      professionalExpense: [0, [Validators.min(0)]],
      taxExemptThreshold: [0, [Validators.min(0)]],
      maxProfessionalExpenseAmount: [0, [Validators.min(0)]],
	  
	  contractNoticePeriod: [0, [Validators.min(0)]],
      trialDuration: [0, [Validators.min(0)]],

      defaultPriceList: '',
      isSalePriceWithFormula: [false],
      isSalePriceWithPu: [true],
      isPointsUse: [false],
      payrollAllowPartialPayment: [false],
      payrollAllowMissingBankAccount: [false],
      payrollPaymentLetterMessage: [''],
    });


    this.systemSettingsForm.get('isPitGrossSalaryPercentage')?.valueChanges.subscribe(value => {
      const percentageControl = this.systemSettingsForm.get('pitGrossSalaryPercentage');
      if (value) {
        percentageControl?.enable();
        percentageControl?.setValidators([Validators.required, Validators.min(0), Validators.max(100)]);
      } else {
        percentageControl?.disable();
        percentageControl?.clearValidators();
      }
      percentageControl?.updateValueAndValidity();
    });
  }

  ngOnInit(): void {
    this.loadSystemSettings();
  }

  get fc(): any {
    return this.systemSettingsForm.controls;
  }
  loadSystemSettings(): void {
    this.systemSettingsService.getCollection().subscribe({
      next: (res: any) => {
        const settings = res['hydra:member'][0];
        this.data = settings;
        this.systemSettingsForm.patchValue(settings);
        this.findDefaultPriceLists();
        // Only need to handle PIT percentage disabled state
        if (!settings.isPitGrossSalaryPercentage) {
          this.systemSettingsForm.get('pitGrossSalaryPercentage')?.disable();
        }
        this.systemSettingsForm.get('defaultPriceList')?.setValue(this.defaultPriceListSelected);
        this.isLoading = false;
      },
      error: () => {
        this.toastr.error(this.translate.instant('load settings error'), 'Error');
        this.isLoading = false;
      }
    });
  }

  onFormSubmit(): void {
    if (this.systemSettingsForm.valid && this.data) {
      this.saving = true;

      this.systemSettingsService.put(this.data.id, this.systemSettingsForm.value).subscribe({
        next: () => {
          this.toastr.success(
              this.translate.instant('settings update success'),
              this.translate.instant('success')
          );
          this.router.navigate(['/dashboard/security']);
          this.loadSystemSettings();
        },
        error: (err) => {
          this.toastr.error(
              this.translate.instant('settings update error'),
              this.translate.instant('error')
          );
          console.error(err);
          this.saving = false;
        }
      });
    }
  }

  findDefaultPriceLists(): any{
    this.priceListService.getCollection().subscribe((data: any) => {
          console.log(data);
          this.defaultPriceLists = data['hydra:member'];
          this.defaultPriceLists = this.defaultPriceLists.map((v) => {
            v.id = v['@id'];
            return v;
          });
        },
        error => console.log(error)
    );
  }
}
